import React from 'react';
import '../../../static/styles/apiguide.scss';
import '../../../static/styles/dashboard.scss';

export default class TicketFreeProcessing extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return(
            <div>
                <h3 className="mb0 mt40">티켓 미사용 처리 API</h3>
                <div className="blog-post-meta">
                                <span
                                    className="s-post">사용된 상태의 티켓을 미사용 상태로 처리합니다. 이 API를 이용해 하나의 티켓을 미사용처리 할 수 있습니다.</span>
                    <h3 className="request-method">
                        <span className="label label-success">POST</span>
                    </h3>
                </div>
                <div className="table-responsive">
                    <table className="table table-striped">
                        <tbody>
                        <tr>
                            <td>Path</td>
                            <td>Example Endpoint</td>
                        </tr>
                        <tr>
                            <td>/v2/providers/travel_backbone_api/apis/ticket-api/v1/tickets/{'{ticketNumber}'}/reclaim</td>
                            <td>
                                https://api-gateway.coupang.com/v2/providers/travel_backbone_api/apis/ticket-api/v1/tickets/7000000000151/reclaim
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <div className="table-responsive mt10">
                    <h4>Request Parameters</h4>
                    <table className="table table-striped">
                        <tbody>
                        <tr>
                            <th colSpan="4" className="bold">Path Segment Parameter</th>
                        </tr>
                        <tr>
                            <th>Name</th>
                            <th>Required</th>
                            <th>Type</th>
                            <th>Description</th>
                        </tr>
                        <tr>
                            <td>ticketNumber</td>
                            <td>O</td>
                            <td>String</td>
                            <td>티켓번호</td>
                        </tr>
                        <tr>
                            <th colSpan="4" className="bold">Body Parameter</th>
                        </tr>
                        <tr>
                            <th>Name</th>
                            <th>Required</th>
                            <th>Type</th>
                            <th>Description</th>
                        </tr>

                        <tr>
                            <td>dealId</td>
                            <td>X</td>
                            <td>Long</td>
                            <td>딜번호 (default = null)</td>
                        </tr>
                        <tr>
                            <td>optionId</td>
                            <td>X</td>
                            <td>Long</td>
                            <td>옵션번호 (default = null)</td>
                        </tr>
                        <tr>
                            <td>quantity</td>
                            <td>X</td>
                            <td>Integer</td>
                            <td>미사용할 수량 (default = 1)</td>
                        </tr>
                        <tr>
                            <td>reclaimReason</td>
                            <td>X</td>
                            <td>String</td>
                            <td>요청사유 (default = "업체귀책")</td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <div className="table-responsive mt40">
                    <h4>Response Specifications</h4>
                    <table className="table table-striped">
                        <tbody>
                        <tr>
                            <th>Name</th>
                            <th>Type</th>
                            <th>Description</th>
                        </tr>
                        <tr>
                            <td>code</td>
                            <td>String</td>
                            <td>응답 코드</td>
                        </tr>
                        <tr>
                            <td>message</td>
                            <td>String</td>
                            <td>응답 메세지</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div className="table-responsive mt40">
                    <div className="panel panel-default">
                        <div className="panel-heading">
                            <h3 className="panel-title">응답값 예시</h3>
                        </div>
                        <div className="panel-body">
                    <pre className="ty01">
                        {`
            {
                "code": "0000",
                "message" : "success"
            }
                        `}
                    </pre>
                        </div>
                    </div>
                </div>

                <div className="table-responsive">
                    <table className="table table-striped">
                        <tbody>
                        <tr>
                            <th>code</th>
                            <th>message</th>
                            <th>설명</th>
                            <th>HTTP CODE</th>
                        </tr>
                        <tr>
                            <td>0000</td>
                            <td>success</td>
                            <td>사용, 미사용 처리 성공</td>
                            <td>200</td>
                        </tr>
                        <tr>
                            <td>0001</td>
                            <td>coupon that was used</td>
                            <td>이미 사용처리된 쿠폰을 사용처리 시도</td>
                            <td>200</td>
                        </tr>
                        <tr>
                            <td>0002</td>
                            <td>coupon that has been canceled</td>
                            <td>취소완료된 쿠폰을 사용, 미사용처리 시도</td>
                            <td>200</td>
                        </tr>
                        <tr>
                            <td>0003</td>
                            <td>system error</td>
                            <td>내부 서버 에러</td>
                            <td>500</td>
                        </tr>
                        <tr>
                            <td>0004</td>
                            <td>invalid parameter</td>
                            <td>파라미터로 받은 쿠폰번호가 유효하지 않을때(쿠폰이 존재하지 않을때)</td>
                            <td>200</td>
                        </tr>
                        <tr>
                            <td>0005</td>
                            <td>coupon useAmount invalid</td>
                            <td>파라미터로 받은 처리수량으로 처리가 불가능할때(ex. 1회 남았는데 2회 사용처리하려고 할때)</td>
                            <td>200</td>
                        </tr>
                        <tr>
                            <td>0006</td>
                            <td>has no parameter</td>
                            <td>필수 입력값을 입력하지 않았을때</td>
                            <td>200</td>
                        </tr>
                        <tr>
                            <td>0007</td>
                            <td>un used coupon</td>
                            <td>한번도 사용처리 되지 않은 쿠폰을 미사용처리 시도</td>
                            <td>200</td>
                        </tr>
                        <tr>
                            <td>0008</td>
                            <td>coupon canceling</td>
                            <td>취소접수된 쿠폰을 사용, 미사용처리 시도</td>
                            <td>200</td>
                        </tr>
                        <tr>
                            <td>0009</td>
                            <td>coupon is already in progress</td>
                            <td>동일 번호의 쿠폰이 사용, 미사용처리 중일때 시도</td>
                            <td>200</td>
                        </tr>
                        <tr>
                            <td>0010</td>
                            <td>couponNumber is duplicated</td>
                            <td>파라미터로 받은 쿠폰번호의 쿠폰이 2개 이상 존재할때</td>
                            <td>500</td>
                        </tr>
                        <tr>
                            <td>0011</td>
                            <td>unauthorized vendor id</td>
                            <td>미인증 vendorId로 쿠폰 처리시도, 미인증은 acl에 등록되지 않은 vendorId인 경우,<br/> 처리하려는 쿠폰의
                                vendorId와 다를 경우
                            </td>
                            <td>401</td>
                        </tr>
                        </tbody>
                    </table>
                </div>

            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./travel-developers-interface/src/main/client/apis/TicketAPIContent/TicketManagementAPI/TicketFreeProcessing.jsx